export const SECONDARY_HEADER_HTML_ID = 'secondary-header';
